import "./scss/index.scss";

import * as React from "react";
import { Link } from "react-router-dom";

import { SOCIAL_MEDIA, STATIC_PAGES, SUPPORT_EMAIL } from "../../core/config";
import SocialMediaIcon from "../SocialMediaIcon";

const supportPage = STATIC_PAGES.find(page => page.slug === "contact-support");

const Footer: React.FC = () => (
  <footer aria-label="Site footer" className="footer" id="footer">
    <div className="footer__content container">
      <section className="footer__brand" aria-labelledby="footer-brand-title">
        <h2 id="footer-brand-title">EGT Supplies</h2>
        <p>
          Professional barber tools and shop essentials, organized to make the
          right products easier to find.
        </p>
      </section>

      <nav aria-label="Shop" className="footer__section">
        <h2>Shop</h2>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/search/">Browse all products</Link>
          </li>
        </ul>
      </nav>

      <nav aria-label="Company and support" className="footer__section">
        <h2>Company &amp; support</h2>
        <ul>
          {STATIC_PAGES.map(page => (
            <li key={page.slug}>
              <Link to={page.url}>{page.label}</Link>
            </li>
          ))}
        </ul>
      </nav>

      <section className="footer__section" aria-labelledby="footer-help-title">
        <h2 id="footer-help-title">Need help?</h2>
        <p>Questions about products, compatibility, or an order?</p>
        <a className="footer__support-link" href={`mailto:${SUPPORT_EMAIL}`}>
          {SUPPORT_EMAIL}
        </a>
        {supportPage && (
          <Link className="footer__support-page" to={supportPage.url}>
            View contact guidance
          </Link>
        )}
      </section>
    </div>

    <div className="footer__bottom container">
      <div
        aria-label="Social media"
        className="footer__social"
        role="navigation"
      >
        {SOCIAL_MEDIA.map(medium => (
          <SocialMediaIcon medium={medium} key={medium.ariaLabel} />
        ))}
      </div>
      <p>
        © {new Date().getFullYear()} Elliott Global Technologies. All rights
        reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
